import { Type } from '@sinclair/typebox';

export const notFoundResponse = {
    '404': {
        description: 'Not found',
    },
};

export const okResponse = {
    '200': {
        description: 'OK',
        content: {
            'application/json': {
                schema: Type.Object({ isSuccessful: Type.Boolean() }),
            },
        },
    },
};

export const createdResponse = {
    '200': {
        description: 'An object with the id',
        content: {
            'application/json': {
                schema: Type.Object({ id: Type.String() }),
            },
        },
    },
};

export const removedResponse = createdResponse;
export const updatedResponse = createdResponse;

export const downloadResponse = {
    '200': {
        description: 'File to download',
        content: {
            'application/octet-stream': {
                schema: {
                    type: 'string',
                    format: 'binary',
                },
            },
        },
    },
};
